export function toQuery(filters?: object): string {
    if (!filters) {
        return '';
    }
    const queryParams = Object.entries(filters)
        .filter(([_, v]) => v !== undefined)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');
    return queryParams ? '?' + queryParams : '';
}
